import * as React from 'react';
import { Tooltip } from 'antd';
import { ApplicationSession } from '../../services/types';
import { TypeUtils } from '../../misc';

interface Props {
    session: ApplicationSession;
}

const CompletedSessionIcon: React.FC<Props> = ({ session }: Props) => {
    const getSessionResultsTooltip = () => {
        if (!session.sessionResults) {
            return null;
        }

        const lines = Object.values(session.sessionResults).reduce<string[]>((acc, resultItem) => {
            if (TypeUtils.isStringArray(resultItem.value) || TypeUtils.isNumberArray(resultItem.value)) {
                return [...acc, `${resultItem.label}: ${resultItem.value.join(', ')}`];
            }

            if (
                TypeUtils.isString(resultItem.value) ||
                TypeUtils.isNumber(resultItem.value) ||
                TypeUtils.isBoolean(resultItem.value)
            ) {
                return [...acc, `${resultItem.label}: ${resultItem.value}`];
            }

            return [...acc];
        }, []);

        if (!lines.length) {
            return null;
        }

        return (
            <div>
                {lines.map((line, index) => (
                    <React.Fragment key={index}>
                        <span>{line}</span>
                        <br />
                    </React.Fragment>
                ))}
            </div>
        );
    };

    return (
        <Tooltip title={getSessionResultsTooltip()}>
            <span
                data-id-name="Status"
                className="closed-session-status"
                style={{ background: '#9BA0AA', fontSize: 11 }}
            >
                Completed
            </span>
        </Tooltip>
    );
};

export default CompletedSessionIcon;
